import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
// import { RangePickerProps } from 'antd/es/date-picker';
// import dayjs from 'dayjs';
import message from "../../Manual/json/message.json";
import status from "../json/status.json";
import { SearchOutlined } from "@ant-design/icons";
import { getProviderListCode } from "../../../../store/SendMessageSlice";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { validations } from "../../../../config/validations/validations";
import { disabledSaveBtn } from "../../../../config/Global";
import { useNavigate } from "react-router-dom";
const SearchForm: React.FC<any> = (props) => {
  const {
    paginationData,
    getList,
    setSavePayload,
    messageAction,
    setMessageAction,
    getInquireList,
    getAddPortNumberList,
    setPaginationData,
    getPublishList,
  } = props;

  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(false);
  const [providerListCode, setProviderListCode] = useState<any>();
  const navigate = useNavigate();

  const updateProviderListCode = () => {
    dispatch(getProviderListCode())
      .then((res: any) => {
        const listOfProviders = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProviders && setProviderListCode(listOfProviders);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  const handleSubmit = (data) => {
    // setSavePayload(data);
    const payload = {
      ...data,
      status: data?.status === "All" ? "" : data?.status,
      ...paginationData,
    };
    if (messageAction === "Inquire_number") {
      setSavePayload(payload);
      getInquireList(payload);
    }
    if (messageAction === "Check") {
      setSavePayload(payload);
      getList(payload);
    }
    if (messageAction === "Publish") {
      const PublishNumberPayload = {
        request_id: data?.request_id,
        number: data?.number,
        current: 1,
        pageSize: 10,
      };
      setSavePayload(PublishNumberPayload);
      getPublishList(payload);
    }
    if (data?.message_action === "Add_portability_number") {
      const AddPortabilityNumberPayload = {
        phone_number: data?.phone_number,
        provider: data?.provider,
        pageNumber: 1,
        pageSize: 10,
      };
      setSavePayload(AddPortabilityNumberPayload);
      getAddPortNumberList(AddPortabilityNumberPayload);
      setPaginationData({
        current: 1,
        page_size: 10,
      });
    }
    if (messageAction === "Start") {
      const StartPortabilityPayload = {
        request_id: data?.request_id,
        number: data?.number,
        from_provider: data.from_provider,
        to_provider: data.to_provider,
        status: data.status,
        current: 1,
        pageSize: 10,
      };
      setSavePayload(StartPortabilityPayload);
      getList(payload);
    }
    setDisabledClear(false);
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  // const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  //   // Can not select days before today and today
  //   return current && current > dayjs().endOf('day');
  // };

  useEffect(() => {
    form.resetFields();
    form.setFieldValue("message_action", messageAction);
  }, [form, messageAction]);
  console.log("messageAction", messageAction);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
        initialValues={{
          fromProvider: "All",
          toProvider: "All",
          lastTransaction: "All",
          status: "All",
        }}
      >
        <Row gutter={[20, 0]} align={"top"}>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Select
              label="Message Action"
              name={"message_action"}
              allowClear
              disabled
              showSearch
              initialValue={messageAction}
              options={{
                list: message && message,
                valueKey: "value",
                textKey: "label",
              }}
              onChange={(val: string) => {
                setMessageAction(val);
                if (val === "Check") {
                  navigate(`/action?action=Start`);
                } else {
                  navigate(`/action?action=${val}`);
                }
                //console.log('val', val);
              }}
              // required
              // rules={[validations.required.select('Message')]}
            />
          </Col>
          {messageAction === "Start" && (
            <>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Request Id"
                  name={"request_id"}
                  rules={[validations.pattern.whitespace]}
                />
              </Col>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Number"
                  name={"number"}
                  rules={[
                    validations.pattern.numericWithSecial,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              <Col xs={24} md={12} lg={4}>
                {""}
              </Col>
              {/* <Col xs={24} md={12} lg={4}>
                <InputBox.DateTimePicker
                  label='From'
                  name={'from_date'}
                  disabledDate={disabledDate}
                />
              </Col>
              <Col xs={24} md={12} lg={4}>
                <InputBox.DateTimePicker
                  label='To'
                  name={'to_date'}
                  disabledDate={disabledDate}
                />
              </Col> */}
              <Col xs={24} md={12} lg={6}>
                <InputBox.Select
                  label="From Provider"
                  name={"from_provider"}
                  allowClear
                  showSearch
                  placeholder="Select From Provider Code"
                  // initialValue={'All'}
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                />
              </Col>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Select
                  label="To Provider"
                  name={"to_provider"}
                  allowClear
                  showSearch
                  placeholder="Select To Provider Code"
                  // initialValue={'All'}
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                />
              </Col>

              <Col xs={24} md={12} lg={4}>
                <InputBox.Select
                  label="Status"
                  name={"status"}
                  allowClear
                  showSearch
                  initialValue={"All"}
                  options={{
                    list: status && status,
                    valueKey: "value",
                    textKey: "label",
                  }}
                />
              </Col>
            </>
          )}
          {messageAction === "Inquire_number" && (
            <>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Request Id"
                  name={"request_id"}
                  rules={[validations.pattern.whitespace]}
                />
              </Col>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Number"
                  name={"number"}
                  rules={[
                    validations.pattern.numericWithSecial,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
            </>
          )}
          {messageAction === "Add_portability_number" && (
            <>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Provider Code"
                  name={"provider"}
                  allowClear
                  showSearch
                  placeholder="Select Provider Code"
                  tooltip="Select on from provided network provider list"
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                  // required
                  // rules={[validations.required.select('Provider Code')]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Phone Number"
                  name={"phone_number"}
                  tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
                  // required
                  rules={[
                    // validations.required.text('Number'),
                    validations.pattern.numericWithSecial,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
            </>
          )}
          {messageAction === "Publish" && (
            <>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Request Id"
                  name={"request_id"}
                  rules={[validations.pattern.whitespace]}
                />
              </Col>
              <Col xs={24} md={12} lg={6}>
                <InputBox.Text
                  label="Number"
                  name={"number"}
                  rules={[
                    validations.pattern.numericWithSecial,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              <Col xs={24} md={12} lg={4}>
                {""}
              </Col>
            </>
          )}
        </Row>
        <Row gutter={[20, 0]}>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button type="primary" htmlType="submit" disabled={disabledSearch}>
              <SearchOutlined /> Search
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button
              type="default"
              // htmlType="reset"
              disabled={disabledClear}
              onClick={() => {
                form.resetFields();
                setSavePayload({});
                if (messageAction === "Check") {
                  getList();
                } else if (messageAction === "Inquire_number") {
                  getInquireList();
                } else if (messageAction === "Add_portability_number") {
                  getAddPortNumberList();
                }
                setDisabledClear(true);
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default SearchForm;
